<template>
    <div class="legal-landing">
        <h1>{{trans.get('legal.cookiesPolicy.title')}}</h1>

            <p>{{trans.get('legal.cookiesPolicy.text1')}}</p>
            <p>{{trans.get('legal.cookiesPolicy.text2')}}</p>
            <p>{{trans.get('legal.cookiesPolicy.text3')}}</p>
            <p>{{trans.get('legal.cookiesPolicy.text4')}}</p>
            <p><strong>{{trans.get('legal.cookiesPolicy.subtitle1')}}</strong></p>
            <p v-html="trans.get('legal.cookiesPolicy.text5')"></p>
            <p><strong>{{trans.get('legal.cookiesPolicy.subtitle2')}}</strong></p>
            <p v-html="trans.get('legal.cookiesPolicy.text6')"></p>
            <p>{{trans.get('legal.cookiesPolicy.text7')}}</p>
            <p>{{trans.get('legal.cookiesPolicy.text8')}}</p>
            <ul>
                <li>{{trans.get('legal.cookiesPolicy.ul.li1')}}
                    <ul>
                        <li>Facebook: <a href="https://www.facebook.com/about/privacy/your-info">https://www.facebook.com/about/privacy/your-info</a></li>
                        <li>Twitter: <a href="https://twitter.com/privacy">https://twitter.com/privacy</a></li>
                    </ul>
                </li>
                <li>{{trans.get('legal.cookiesPolicy.ul.li2')}}
                    <ul>
                        <li>
                            Facebook: <a href="https://www.facebook.com/about/privacy/your-info">https://www.facebook.com/about/privacy/your-info</a>
                        </li>
                    </ul>
                </li>
                <li>
                   {{trans.get('legal.cookiesPolicy.ul.li3')}}
                    <ul>
                        <li>
                            Google Analytics: <a href="http://www.google.com/intl/es/policies/">http://www.google.com/intl/es/policies/</a>
                        </li>
                    </ul>
                </li>
            </ul>
            <p>{{trans.get('legal.cookiesPolicy.text9')}}</p>
            <p><strong>{{trans.get('legal.cookiesPolicy.subtitle3')}}</strong></p>
            <p>{{trans.get('legal.cookiesPolicy.text9')}}</p>


    </div>
</template>

<script>
export default {};
</script>
